export enum EnumTipoDeCobrancaDeAdicional {
  SOMA = "SOMA",
  MEDIA = "MEDIA",
  MAIOR = "MAIOR"
}
